import React, { useEffect, useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { UseQueryResult } from "react-query";
import { useCompanySendingStatus } from "../../hooks/company.hooks";
import { SENDING_STATUS } from "../../commons/enum";

import "./sending-status-alert.scss";

interface SendingStatusAlertProps {
  companyId?: string;
}

const SendingStatusAlert: React.FC<SendingStatusAlertProps> = ({
  companyId,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [alertData, setAlertData] = useState<{
    status: string;
    message: string;
    type: "error" | "warning";
  } | null>(null);

  const { data: sendingStatus, isSuccess } = useCompanySendingStatus(
    companyId
  ) as UseQueryResult<any, unknown>;

  useEffect(() => {
    if (!(isSuccess && sendingStatus?.status)) {
      return;
    }
    const { status } = sendingStatus;

    if (status === SENDING_STATUS.DISABLED) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setAlertData({
        status: "DISABLED",
        message:
          'Email sending ability is paused due to suspicious activities that would damage the system\'s email reputation, reach us at <a href="mailto:support@wealthx.au" style="color: inherit; font-weight: bold; text-decoration: underline;">support@wealthx.au</a> for more details',
        type: "error",
      });
      setIsVisible(true);
    }
  }, [isSuccess, sendingStatus]);

  const handleClose = () => {
    setIsVisible(false);
  };

  return (
    isVisible && (
      <Box
        className={`sending-status-alert sending-status-alert--${alertData.type}`}
      >
        <Typography
          className="sending-status-alert__message"
          dangerouslySetInnerHTML={{ __html: alertData.message }}
        />
        <IconButton
          size="small"
          onClick={handleClose}
          className="sending-status-alert__close-button"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    )
  );
};

export default SendingStatusAlert;
